import {WicketAdminUserChangelogAgreement} from '../wicket-admin-user-agreement';

export interface WicketAdminUserAgreementChangelogEntry {
  fk_agreement_id: number;
  change_to: boolean;
  operation_type: string;
  created_at: string;
  updater_type: string;
  updater_id: string | null;
  agreement: WicketAdminUserChangelogAgreement;
}
